/* src/app/main/pages/news/news.component.css */
/*# sourceMappingURL=news.component.css.map */
